import * as React from 'react';
import bind from '@reverbdotcom/commons/dist/bind';
import * as I18n from 'i18n-js';
import {
  core_apimessages_Address,
  core_apimessages_Country as ICountry,
  Countries,
} from '../schemas/rql';
import ControlledCheckbox from '@reverbdotcom/commons/dist/components/controlled_checkbox';
import { ChildProps } from 'react-apollo';
import withCountriesApollo from '../components/addresses/with_countries_apollo';
import AddressFields from '../components/shared/addresses/address_fields';
import { AddressSummary } from '../components/addresses/address_summary';
import CheckoutBillingAddressPlaceholder from './checkout_billing_address_placeholder';
import SelectableCreditCardListError from './selectable_credit_card_list_error';

export interface ICheckoutBillingAddressProps {
  showBillingSameAsShippingOption: boolean;
  showPhoneField: boolean;
  billingAddress: core_apimessages_Address;
  belowCreditCardThreshold: boolean;
}

interface IState {
  billingSameAsShippingSelected: boolean;
  address: core_apimessages_Address;
}

type IProps = ChildProps<ICheckoutBillingAddressProps, Countries.Query>;

export class CheckoutBillingAddressFormWithoutApolloCountries extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      billingSameAsShippingSelected: true,
      address: props.billingAddress,
    };
  }

  @bind
  updateBillingSameAsShippingSelected(billingSameAsShippingSelected) {
    this.setState(billingSameAsShippingSelected);
  }

  countries(): ICountry[] {
    return this.props.data.countries.countries;
  }

  billingSameAsShippingCheckbox() {
    if (!this.props.showBillingSameAsShippingOption) {
      return (
        <input
          name="payment[billing_address_same_as_shipping]"
          type="hidden"
          value="false"
        />
      );
    }

    return (
      <div>
        <div className="label-with-checkbox mb-half">
          <input
            name="payment[billing_address_same_as_shipping]"
            type="hidden"
            value={`${this.state.billingSameAsShippingSelected}`}
          />
          <ControlledCheckbox
            id="payment_billing_address_same_as_shipping"
            fieldName="billingSameAsShippingSelected"
            inputName="billingSameAsShippingSelected"
            updateField={this.updateBillingSameAsShippingSelected}
            checked={this.state.billingSameAsShippingSelected}
          />
          <label htmlFor="payment_billing_address_same_as_shipping">
            {I18n.t('discovery.checkoutBillingAddressForm.sameAsShippingAddress')}
          </label>
        </div>

        {this.displayDefaultAddress()}
      </div>
    );
  }

  displayDefaultAddress() {
    if (!this.state.billingSameAsShippingSelected) { return null; }
    return (
      <AddressSummary
        address={this.props.billingAddress}
        data={this.props.data}
      />
    );
  }

  @bind
  updateAddress(data) {
    this.setState({ address: data });
  }

  showBillingAddressForm() {
    if (!this.props.showBillingSameAsShippingOption) { return true; }
    return !this.state.billingSameAsShippingSelected;
  }

  @bind
  buildInputName(inputName: string) {
    return `payment[billing_address][${inputName}]`;
  }

  renderBillingAddressForm() {
    if (!this.showBillingAddressForm()) { return null; }
    return (
      <AddressFields
        name={this.state.address.name}
        address={this.state.address}
        addressTitle={I18n.t('discovery.checkoutBillingAddressForm.streetAddress')}
        onUpdate={this.updateAddress}
        showPhone={this.props.showPhoneField}
        countriesForSelect={this.countries()}
        buildInputName={this.buildInputName}
        phoneInputRequired
      />
    );
  }

  render() {
    if (this.props.data.loading) { return <CheckoutBillingAddressPlaceholder />; }
    if (this.props.data.error) { return <SelectableCreditCardListError />; }
    return (
      <div className="module">
        <h3 className="heading-3 mb-1">
          {I18n.t('discovery.checkoutBillingAddressForm.billingAddress')}
        </h3>
        {this.billingSameAsShippingCheckbox()}
        {this.renderBillingAddressForm()}
      </div>
    );
  }
}

const CheckoutBillingAddressForm = withCountriesApollo(CheckoutBillingAddressFormWithoutApolloCountries);

export default CheckoutBillingAddressForm;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/checkout_billing_address_form.tsx